<template>
    
<div class="nadi-intro">
    <div class="logo">
    <svg id="nadiIconSm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.22 91.22"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect x="0.25" y="0.25" width="90.72" height="90.72" class="cls-1nadiicon"></rect><polygon points="70.32 55.85 80.56 45.61 70.32 35.36 70.32 20.89 55.84 20.89 45.61 10.65 35.37 20.89 20.88 20.89 20.88 35.37 10.65 45.61 20.88 55.85 20.88 70.32 35.35 70.32 45.6 80.57 55.84 70.33 70.32 70.34 70.32 55.85" class="cls-2nadiicon"></polygon><path d="M30.77,40.18l-.32.21-4.31-.82v23h3.32V48.75a7,7,0,0,1,3.84-6.21V39A10.54,10.54,0,0,0,30.77,40.18Z" class="cls-3nadiicon"></path><path d="M53.65,38.48a10.26,10.26,0,0,0-7.91,3.73l-.72.87-.72-.87A10.05,10.05,0,0,0,39.65,39v3.59a7,7,0,0,1,3.77,6.18v13.9h3.33V48.75a6.95,6.95,0,1,1,13.9,0v13.9H64V48.75A10.27,10.27,0,0,0,53.7,38.48Z" class="cls-3nadiicon"></path><path d="M52,43.54v6.71h3.36V43.51a5.46,5.46,0,0,0-3.36,0Z" class="cls-3nadiicon"></path><path d="M55.33,37.13v-1.9A10.29,10.29,0,0,0,45.06,25a10.15,10.15,0,0,0-6,2l-.2.15-4.07-.78V50.22h3.36v-15a6.92,6.92,0,0,1,13.83,0v1.91a12.81,12.81,0,0,1,3.35,0Z" class="cls-3nadiicon"></path></g></g></svg>
    <!-- <img style="width: 100%;" alt="nadi-mama" src="@/assets/img/nadi-loop.gif"> -->

</div>
<div class="body">
<p>
Welcome to Nadi Mama, the home for all things the Mama Group has to offer. Swipe through to see some of our latest special offerings hand curated by our lead chef, browse the full menu and order items individually, peruse our new retail items, learn more about wholesale resale opportunities of our house made products, make reservations for a special night at one of our locations, or simply stay in touch with us!


</p>
</div>
    
</div>


</template>



<script>
export default {
    name: 'NadiIntro'
}
</script>


<style lang="scss">
.nadi-intro{
    
svg{
    margin: 0 auto;
}

}


.logo{
    // width: 20%;
    // margin: 0 auto;

    width: 26%;
    margin: 0 auto;


   @media only screen and (max-width: 992px) {
    width: 40%;
    margin: 0 auto;
   }


   @media only screen and (max-width: 640px) {
    width: 100%;
    margin: 0 auto;
   }



}





.body p{
    width: 80%;
    margin: 20px auto;
    line-height: 2;
    font-size: 24px;
    line-height: 1.6;
    color: #f05d5b;
text-transform: lowercase;
       @media only screen and (max-width: 992px) {
    font-size: 16px;
    line-height: 1.4;

       }

}

</style>